// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"AntdUploadChildren--next-sr-only--ITtbtrH","uploadButton":"AntdUploadChildren--uploadButton--3Ojgn3X"};